import { PropsWithChildren } from "react"
import { useLanguageProvider } from "./hooks/useLanguageProvider"
import { IntlProvider } from "react-intl"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { csCZ } from "@mui/x-date-pickers/locales"
import "dayjs/locale/cs"
import "dayjs/locale/pl"
import _ from "lodash"
import { LanguageContext } from "./constants"
import { AppLocale, DEFAULT_LOCALE } from "@/config/locales"

export type LanguageProviderProps = PropsWithChildren<{ locale: AppLocale }>

const LanguageProvider = ({ children, locale }: LanguageProviderProps) => {
    const { contextValue, messages } = useLanguageProvider(locale)

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={contextValue.locale}
            localeText={{
                ...csCZ.components.MuiLocalizationProvider.defaultProps.localeText,
                fieldYearPlaceholder() {
                    return "RRRR"
                },
            }}
        >
            <LanguageContext.Provider value={contextValue}>
                {messages && (
                    <IntlProvider locale={contextValue.locale} defaultLocale={DEFAULT_LOCALE} messages={messages}>
                        {children}
                    </IntlProvider>
                )}
            </LanguageContext.Provider>
        </LocalizationProvider>
    )
}
export default LanguageProvider
